import * as i0 from "@angular/core";
var AnalyticsService = /** @class */ (function () {
    function AnalyticsService() {
    }
    AnalyticsService.prototype.pageTrack = function (path) {
        if (typeof gtag !== 'undefined' && gtag && GA_TRACKING_ID) {
            gtag('config', GA_TRACKING_ID, { page_path: path });
        }
    };
    AnalyticsService.prototype.eventTrack = function (action, properties) {
        if (properties === void 0) { properties = {}; }
        if (typeof gtag !== 'undefined' && gtag && GA_TRACKING_ID) {
            gtag('event', action, properties);
        }
    };
    AnalyticsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AnalyticsService_Factory() { return new AnalyticsService(); }, token: AnalyticsService, providedIn: "root" });
    return AnalyticsService;
}());
export { AnalyticsService };
